import React, { useState, useEffect, useCallback } from "react";
import Modal from 'react-bootstrap/Modal';
import {  FORMAT_TIME_VALUE } from "helpers/common";

export default ({openModalValue, openModalClose, currentPrefrences}) => {
    return(
        <>
         <Modal
                show={openModalValue}
                onHide={openModalClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                <Modal.Title>Weekly Match Preferences</Modal.Title>
                </Modal.Header>
                <hr/>
                <Modal.Body>
                {currentPrefrences?.length > 0 &&
                <div className="table-responsive">
                    <table className="table">
                    <thead>
                        <tr>
                        <th> Select Day </th>
                        <th> Earliest Start Time  </th>
                        <th> Latest Start Time  </th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPrefrences?.length > 0 && currentPrefrences?.map((day, i) => {
                            return(
                                <>
                                <tr key={i}>
                                    <td> 
                                        <h5>{day.day}</h5>
                                    </td>
                                    <td> 
                                        {FORMAT_TIME_VALUE(day.start_date)}
                                    </td>
                                    <td>
                                        {FORMAT_TIME_VALUE(day.last_date)}
                                    </td>
                                </tr>
                                </>
                            )
                        })}
                    </tbody>
                    </table>
                </div>
                }
                </Modal.Body>
            </Modal>
        </>

    );
};